import config from './config';

class User {

  static async login(username, password) {

    console.log('Trying to log in: ', config.backend[process.env.NODE_ENV] + '/dashboard/login')

    let response = await fetch(config.backend[process.env.NODE_ENV] + '/dashboard/login', {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: username,
        password: password
      })
    })

    let user = (response.status === 200) ? await response.json() : null
    console.log(user)


    return {
      loggedIn: response.status === 200,
      user: user
    }

  }

}


export { User };


// WEBPACK FOOTER //
// ./src/services/user.js